/**
 * Pulls the guest wishlist out of localStorage once the app has mounted.
 *
 * Deliberately after `app:mounted` rather than in plugin setup: plugins run
 * before the Vue app hydrates, so reading storage there would make the first
 * client render disagree with the server-rendered markup and every heart on the
 * page would hydration-mismatch. Waiting one beat keeps cached HTML valid for
 * everyone and lets the saved state paint immediately afterwards.
 */
export default defineNuxtPlugin({
  name: 'guest-wishlist',
  setup(nuxtApp) {
    // Resolved here, in setup, where the Nuxt instance is active.
    const guest = useGuestWishlist()

    nuxtApp.hook('app:mounted', () => {
      guest.load()
    })

    // Another tab saving something is the same visitor changing the same list,
    // so follow it rather than letting whichever tab writes last win.
    window.addEventListener('storage', (event) => {
      if (event.key === 'guest-wishlist')
        guest.syncFromStorage()
    })
  },
})
